document.addEventListener('DOMContentLoaded', function() {
  var popup = document.getElementById('mp2');
  if (!popup) return;
  var lastTrigger = null;
  var hideTimer = null;

  function hydrateLocalizationLists() {
    popup.querySelectorAll('template[data-localization-options]').forEach(function(template) {
      template.parentElement.appendChild(template.content.cloneNode(true));
      template.remove();
    });
  }

  function openPopup(trigger) {
    window.clearTimeout(hideTimer);
    lastTrigger = trigger;
    hydrateLocalizationLists();
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function() {
      popup.classList.add('visible');
    });
    document.querySelectorAll('[data-localization-modal-trigger]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
    popup.querySelector('.close_mp2')?.focus();
  }

  function closePopup() {
    popup.classList.remove('visible');
    popup.setAttribute('aria-hidden', 'true');
    hideTimer = window.setTimeout(function() {
      popup.hidden = true;
    }, 300);
    document.querySelectorAll('[data-localization-modal-trigger]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    lastTrigger?.focus();
  }

  // Open
  document.querySelectorAll('[data-localization-modal-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup(btn);
    });
  });

  // Close
  document.querySelectorAll('.close_mp2, .close_mp2_button').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      closePopup();
    });
  });

  // Close on overlay click
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('visible')) {
      closePopup();
    }
  });
});

// Localization Form
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.disclosure__button') || this.querySelector('.popout__toggle');
    this.panel = this.querySelector('.disclosure__list');
    this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');

    if (this.button) {
      this.button.addEventListener('click', this.toggle.bind(this));
      this.button.addEventListener('focusout', this.close.bind(this));
    }
    this.addEventListener('keyup', function(e) { if (e.code === 'Escape') this.close(); }.bind(this));
    this.addEventListener('click', function(e) {
      var link = e.target.closest('a[data-value]');
      if (link && this.contains(link)) this.select(e, link);
    }.bind(this));
  }

  toggle() {
    if (!this.button || !this.panel) return;
    var expanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', !expanded);
    this.panel.toggleAttribute('hidden');
  }

  close(e) {
    if (!this.button || !this.panel) return;
    if (e && e.relatedTarget && this.contains(e.relatedTarget)) return;
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('hidden', '');
  }

  select(e, link) {
    e.preventDefault();
    if (!this.input) return;
    this.input.value = link.dataset.value;
    this.querySelector('form')?.submit();
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
